/* ==========================================================================
   MONTAGE-THEME · <mt-ugc-steuerung>
   --------------------------------------------------------------------------
   Bedienung auf den Kundenkacheln: anhalten und Ton.

   Die Kacheln laufen stumm in Schleife an, weil jeder Browser Autoplay nur
   ohne Ton erlaubt. Wer mehr will, bekommt hier zwei Knoepfe: einen fuer
   Wiedergabe und Pause, einen fuer den Ton. Gross ansehen macht weiterhin
   <mt-lightbox>, ein Klick auf das Medium selbst.

   Fortschrittliche Verbesserung, gleiche Regel wie in montage-lightbox.js:
   die Knoepfe stehen NICHT im Markup, sondern entstehen erst hier. Ohne
   Skript bleibt die Reihe eine Reihe stummer Schleifen, statt zwei Knoepfe
   zu zeigen, die nichts tun.

   Zwei Dinge, die sonst unangenehm auffallen:
     · Ton ist exklusiv. Wer eine Kachel laut stellt, macht die uebrigen
       stumm, sonst reden vier Menschen gleichzeitig.
     · Solange das Vollbild offen ist, schweigt und ruht die Reihe. Der
       Klon im Vollbild bringt seinen eigenen Ton mit, und ohne das hier
       laeuft beides uebereinander.
   ========================================================================== */
(function () {
  const SYMBOL = {
    pause:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor"><rect x="7" y="5" width="3.4" height="14" rx="1"/><rect x="13.6" y="5" width="3.4" height="14" rx="1"/></svg>',
    abspielen:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor"><path d="M8 5.2v13.6l11-6.8L8 5.2z"/></svg>',
    tonAn:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4v-5z" fill="currentColor"/><path d="M15.5 9.2a4 4 0 010 5.6M18 6.8a7.5 7.5 0 010 10.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>',
    tonAus:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4v-5z" fill="currentColor"/><path d="M16 10l4.5 4.5M20.5 10L16 14.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>',
  };

  class MontageUgcSteuerung extends HTMLElement {
    connectedCallback() {
      /* Im Theme-Editor setzt Shopify die Sektion beim Bearbeiten neu ins
         Dokument. Ohne diese Bremse haengt an jeder Kachel eine zweite
         Knopfleiste. Gleiche Falle wie in montage-lightbox.js. */
      if (this.aufgebaut) return;
      this.videos = Array.from(this.querySelectorAll('video'));
      if (!this.videos.length) return;
      this.aufgebaut = true;

      this.videos.forEach((video) => this.ruesteAus(video));
      this.beobachteVollbild();
    }

    disconnectedCallback() {
      this.waechter?.disconnect();
      this.aufgebaut = false;
    }

    ruesteAus(video) {
      const karte = video.closest('.mt-pdp-ugc__karte');
      if (!karte) return;

      const leiste = document.createElement('span');
      leiste.className = 'mt-pdp-ugc__steuerung';
      const lauf = this.knopf();
      const ton = this.knopf();

      const zeigeLauf = () => {
        const laeuft = !video.paused;
        lauf.innerHTML = laeuft ? SYMBOL.pause : SYMBOL.abspielen;
        lauf.setAttribute('aria-label', laeuft ? this.text('pause') : this.text('abspielen'));
      };
      const zeigeTon = () => {
        ton.innerHTML = video.muted ? SYMBOL.tonAus : SYMBOL.tonAn;
        ton.setAttribute('aria-label', video.muted ? this.text('tonAn') : this.text('tonAus'));
      };

      lauf.addEventListener('click', () => {
        if (video.paused) video.play();
        else video.pause();
      });

      ton.addEventListener('click', () => {
        const einschalten = video.muted;
        // Ton ist exklusiv: nur eine Kachel darf sprechen.
        if (einschalten) this.videos.forEach((v) => v !== video && (v.muted = true));
        video.muted = !einschalten;
        // Wer den Ton anmacht, will auch sehen. Eine pausierte Kachel
        // laeuft dann wieder an.
        if (!video.muted && video.paused) video.play();
      });

      /* An den Zustand des Videos gehaengt, nicht an den Klick: so stimmt
         die Beschriftung auch, wenn der Browser die Wiedergabe von sich
         aus anhaelt, etwa beim Wechsel des Tabs. */
      video.addEventListener('play', zeigeLauf);
      video.addEventListener('pause', zeigeLauf);
      video.addEventListener('volumechange', zeigeTon);

      zeigeLauf();
      zeigeTon();
      leiste.append(lauf, ton);
      karte.appendChild(leiste);
    }

    /* montage-lightbox.js setzt beim Oeffnen die Klasse mt-lightbox-offen
       an <html>. Daran haengt sich das hier, statt in die Lightbox
       hineinzugreifen: die gehoert mehreren Sektionen. */
    beobachteVollbild() {
      this.waechter = new MutationObserver(() => {
        if (document.documentElement.classList.contains('mt-lightbox-offen')) {
          this.videos.forEach((v) => {
            v.muted = true;
            v.pause();
          });
        }
      });
      this.waechter.observe(document.documentElement, { attributeFilter: ['class'] });
    }

    knopf() {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'mt-pdp-ugc__knopf';
      return b;
    }

    /* Rueckfalltexte bewusst auf Englisch: fehlt ein Attribut, faellt es
       im deutschen Laden sofort auf. */
    text(schluessel) {
      const rueckfall = {
        abspielen: 'Play video',
        pause: 'Pause video',
        tonAn: 'Turn sound on',
        tonAus: 'Turn sound off',
      };
      return this.dataset['text' + schluessel[0].toUpperCase() + schluessel.slice(1)] || rueckfall[schluessel];
    }
  }

  if (!customElements.get('mt-ugc-steuerung')) {
    customElements.define('mt-ugc-steuerung', MontageUgcSteuerung);
  }
})();
